import { CSSProperties, useEffect, useRef } from 'react';
import { Paper } from '@mui/material';
import { audioPath } from 'constants/audioConstants';
import { SEAT_CONTAINER_WIDTH } from 'constants/gameConstants';
import gsap from 'gsap';
import useSound from 'hooks/useSound';
import { currencyFormatter } from 'utils/functions';

type BountyWinnerPropType = {
  totalHandBounty: number;
  backgroundColor?: string;
  /** See WinnerMsg — same PLAYERWINS parity gate, decided by the caller. */
  soundEnabled?: boolean;
};

export const BountyWinner = ({
  totalHandBounty,
  backgroundColor = '#628B48',
  soundEnabled = true
}: BountyWinnerPropType) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [playPlayerWin] = useSound(audioPath.playerWins);

  useEffect(() => {
    if (soundEnabled) playPlayerWin();
  }, [playPlayerWin, soundEnabled]);

  useEffect(() => {
    if (!elementRef.current) return;
    const tween = gsap.fromTo(
      elementRef.current,
      { top: '0px', opacity: 0, left: '0px' },
      {
        top: `${10 + SEAT_CONTAINER_WIDTH}px`,
        opacity: 1,
        left: `${50 + SEAT_CONTAINER_WIDTH}px`,
        duration: 0.5,
        ease: 'power3.out'
      }
    );
    return () => {
      tween.kill();
    };
  }, []);

  return (
    <div ref={elementRef} style={msgContainer}>
      <Paper sx={{ ...textStyle, backgroundColor }} elevation={6}>
        Bounty +{currencyFormatter(totalHandBounty)}
      </Paper>
    </div>
  );
};

const msgContainer: CSSProperties = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
};

const textStyle: CSSProperties = {
  borderRadius: '3rem',
  textAlign: 'center',
  fontSize: '1rem',
  color: '#e1e1e2',
  padding: '0.5rem 1rem',
  whiteSpace: 'nowrap',
  fontWeight: '800',
  textTransform: 'uppercase',
  display: 'flex'
};
